/*
  Follow this https://gist.github.com/scokmen/f813c904ef79022e84ab2409574d1b45
  while adding new HTTP status code to this enum
*/
export enum HttpStatusCode {
  Ok = 200,
  NotAuthorized = 401,
  Forbidden = 403,
}
